export function lockScreenOrientationTo(orientation: string) {
    try {
        if (cordova) {
            // tslint:disable-next-line:no-any
            (screen as any).orientation.lock(orientation);
        }
    } catch {}
}

export function unlockScreenOrientation() {
    try {
        if (cordova) {
            // tslint:disable-next-line:no-any
            (screen as any).orientation.unlock();
        }
    } catch {}
}

export function lockScreenOrientationToPortrait() {
    try {
        if (cordova) {
            // tslint:disable-next-line:no-any
            (screen as any).orientation.lock("portrait");
        }
    } catch {}
}

export function enableZoom() {
    try {
        if (cordova) {
            (screen as any).togglezoom.toggleOn();
        }
    } catch {}
}

export function disableZoom() {
    try {
        if (cordova) {
            (screen as any).togglezoom.toggleOff();
        }
    } catch {}
}



// WEBPACK FOOTER //
// ./src/util/screen.ts